import React, { useEffect } from "react";

const isBotUserAgent = (userAgent) => {
  const bots = ['Googlebot', 'Bingbot', 'Slurp', 'DuckDuckBot', 'Baiduspider', 'YandexBot'];
  return bots.some(bot => userAgent.toLowerCase().includes(bot.toLowerCase()));
};

const CountryRedirect = ({ onCheckComplete }) => {
  useEffect(() => {
    const checkLocationAndRedirect = async () => {
      try {
        const userAgent = navigator.userAgent;
        
        // Skip redirection for bots
        if (isBotUserAgent(userAgent)) {
          onCheckComplete(true);
          return;
        }

        // Fetch location data from ipinfo.io or "https://ipapi.co/json/"
        const response = await fetch("https://ipinfo.io/json");
        const data = await response.json();
        const countryCode = data.country; // ipinfo uses 'country' for country code

        const allowedCountries = [
          "US", "CA", "VI", "TC", "TT", "BS", "SX", "VC", "PM", "MF", "LC", "KN", "BL", "PR", "PA", 
          "NI", "AN", "MS", "MX", "MQ", "JM", "HN", "HT", "GT", "GP", "GD", "GL", "SV", "DO", "DM", 
          "CW", "CU", "CR", "KY", "VG", "BQ", "BM", "BZ", "BB", "AW", "AG", "AI", "AR", "BO", "BR", 
          "CL", "CO", "EC", "FK", "GF", "GY", "PY", "PE", "SR", "UY", "VE", "AT", "BE", "BG", "HR", 
          "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", 
          "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "GB", "IS", "NO", "LI", "CH", "BA", "ME", 
          "MD", "MK", "GE", "AL", "RS", "TR", "UA", "AM", "BY", "AZ"
        ];

        // Redirect if the country is allowed
        if (!allowedCountries.includes(countryCode)) {
          window.location.replace("https://vymo.com");
        } else {
          onCheckComplete(false);
        }
      } catch (error) {
        console.error("Error in country check or redirection:", error);
        onCheckComplete(false);
      }
    };

    checkLocationAndRedirect();
  }, [onCheckComplete]);

  return null;
};

export default CountryRedirect;
